/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { Box, Flex } from '@cfacorp/cowponents';
import DeliveryTipsSelectButton from './DeliveryTipsSelectButton';
import DeliveryTipsCustomAmount from './DeliveryTipsCustomAmount';
import { formatPrice } from '../../util/format';
import Icon from '../Icon';

const DeliveryTips = (props) => {
  const PERCENTAGE_DEFAULTS = [0.05, 0.1, 0.15];
  const DOLLAR_DEFAULTS = [1, 3, 5];

  const { subTotal, selectedCustomTipValue, addDeliveryTip } = props;
  const isDollar = subTotal <= 25;
  const BUTTON_DEFAULTS = isDollar
    ? DOLLAR_DEFAULTS
    : PERCENTAGE_DEFAULTS.map((percentage) => +(percentage * subTotal).toFixed(2));

  const [isCustom, setIsCustom] = useState(selectedCustomTipValue > 0);
  const [previousCustom, setPreviousCustom] = useState(0);
  const onClickHandler = (e) => {
    addDeliveryTip('tipAmount', e.target.value);
    setIsCustom(false);
  };

  const beforeInputHandler = (e) => {
    setPreviousCustom(e.target.value);
  };

  const onInputHandler = (e) => {
    if (e.target.value > 9999) {
      e.target.value = previousCustom;
    }
    if (
      e.target.value.toString().split('.').length > 1 &&
      e.target.value.toString().split('.')[1].length > 2
    ) {
      e.target.value = parseFloat(e.target.value).toFixed(2);
    }
  };

  const onKeyDownHandler = (e) => {
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const onBlurHandler = (e) => {
    e.preventDefault();
    if (e.target.value !== '') {
      addDeliveryTip('tipAmount', e.target.value);
    }
  };

  return (
    <StyledDeliveryTips className="styled-delivery-tips">
      <div className="delivery-tip-intro">Tip amount</div>
      <div className="delivery-tip-intro-sub">100% of tips will go to Team Members</div>
      <Flex display="flex" flexWrap="wrap">
        <Box width={[1 / 2, 1 / 5]}>
          <DeliveryTipsSelectButton
            tipPercentageButtonId="button-no-tip"
            onClickHandler={onClickHandler}
            checked={!isCustom && selectedCustomTipValue === 0}
            className="select-tip-button"
            labelText="No Tip"
            value={0}
          >
            <Icon>line</Icon>
          </DeliveryTipsSelectButton>
        </Box>
        {BUTTON_DEFAULTS.map((amount, index) => (
          <Box width={[1 / 2, 1 / 5]} key={amount}>
            <DeliveryTipsSelectButton
              tipPercentageButtonId={`tip-${amount}`.replace('.', '')}
              onClickHandler={onClickHandler}
              checked={!isCustom && selectedCustomTipValue === amount}
              className="select-tip-button"
              labelText={`${formatPrice(isDollar ? amount + subTotal : amount)}`}
              value={amount}
            >
              {isDollar ? `$${amount}` : `${PERCENTAGE_DEFAULTS[index] * 100}%`}
            </DeliveryTipsSelectButton>
          </Box>
        ))}
        <Box width={[1 / 2, 1 / 5]}>
          <DeliveryTipsSelectButton
            tipPercentageButtonId="button-custom-tip"
            onClickHandler={() => {
              setIsCustom(true);
              addDeliveryTip('tipAmount', 0);
            }}
            checked={isCustom}
            className="select-tip-button"
            labelText="Custom"
            value={-1}
          >
            <Icon>edit</Icon>
          </DeliveryTipsSelectButton>
        </Box>
        {isCustom && (
          <Box width={[1]}>
            <DeliveryTipsCustomAmount
              isSelect={isCustom}
              onBlurHandler={onBlurHandler}
              onInputHandler={onInputHandler}
              beforeInputHandler={beforeInputHandler}
              onKeyDownHandler={onKeyDownHandler}
              selectedCustomTipValue={selectedCustomTipValue}
            />
          </Box>
        )}
      </Flex>
    </StyledDeliveryTips>
  );
};

const StyledDeliveryTips = styled('div')`
  padding: 16px;
  background: ${(props) => props.theme.background};
  border-radius: 10px;
  & .delivery-tip-intro {
    color: ${(props) => props.theme.bold};
    font-size: 14px;
    font-weight: 700;
    margin: 0 0 5px;
  }
  & .delivery-tip-intro-sub {
    color: ${(props) => props.theme.text};
    font-size: 14px;
    font-weight: 400;
    margin: 0 0 5px;
  }
`;

DeliveryTips.propTypes = {
  subTotal: PropTypes.number,
  selectedCustomTipValue: PropTypes.number,
  addDeliveryTip: PropTypes.func,
};

DeliveryTips.defaultProps = {
  subTotal: 0,
  selectedCustomTipValue: 0,
  addDeliveryTip: () => {},
};

export default DeliveryTips;
